<div class="wizard-inner-container">
    <div class="wizard-registration-title">{{'onboarding.titles.link_pos' | translate}}</div>
    <div class="wizard-form">

        <div *ngIf="loading" class="wizard-loading">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                               animationDuration=".5s">
            </p-progressSpinner>
            <div>{{ 'onboarding.messages.verifying_account' | translate}}</div>
        </div>

        <div class="row margin-top-32">
          <div class="col-md-12">
            <div *ngIf="partner && selectPOS && selectPOS.POSID===3">
              <app-link-vend [partner]="partner" [selectedPOS]="selectPOS" (next)="done($event)"></app-link-vend>
            </div>
            <div *ngIf="partner && selectPOS && selectPOS.POSID===6">
              <app-link-lightspeed [partner]="partner" [selectedPOS]="selectPOS"
                                   (next)="done($event)"></app-link-lightspeed>
            </div>
            <div *ngIf="partner && selectPOS && selectPOS.POSID===8">
              <app-link-xero [partner]="partner" [selectedPOS]="selectPOS" (next)="done($event)"></app-link-xero>
            </div>
            <div *ngIf="partner && selectPOS && selectPOS.POSID===9">
              <app-link-shopify [partner]="partner" [selectedPOS]="selectPOS"
                                (next)="done($event)"></app-link-shopify>
            </div>
            <div *ngIf="partner && selectPOS && selectPOS.POSID===11">
              <app-link-northmill [partner]="partner" [selectedPOS]="selectPOS"
                                  (next)="done($event)"></app-link-northmill>
            </div>
            <div *ngIf="partner && selectPOS && selectPOS.POSID===12">
              <app-link-retailexpress [partner]="partner" [selectedPOS]="selectPOS"
                                      (next)="done($event)"></app-link-retailexpress>
            </div>
            <div *ngIf="partner && selectPOS && selectPOS.POSID===13">
              <app-link-citruslime [partner]="partner" [selectedPOS]="selectPOS"
                                   (next)="done($event)"></app-link-citruslime>
            </div>
            <div *ngIf="partner && selectPOS && selectPOS.POSID===14">
              <app-link-eposnow [partner]="partner" [selectedPOS]="selectPOS"
                                (next)="done($event)"></app-link-eposnow>
            </div>
            <div *ngIf="partner && selectPOS && selectPOS.POSID===15">
              <app-link-wilmar [partner]="partner" [selectedPOS]="selectPOS"
                               (next)="done($event)"></app-link-wilmar>
            </div>
            <div *ngIf="partner && selectPOS && selectPOS.POSID===16">
              <app-link-netsuite [partner]="partner" [selectedPOS]="selectPOS"
                                 (next)="done($event)"></app-link-netsuite>
            </div>
            <div *ngIf="partner && selectPOS && selectPOS.POSID===17">
              <app-link-square [partner]="partner" [selectedPOS]="selectPOS"
                               (next)="done($event)"></app-link-square>
            </div>

            <div *ngIf="partner && selectPOS && selectPOS.POSID===10">
              <app-link-dear [partner]="partner" [selectedPOS]="selectPOS"
                                   (next)="done($event)"></app-link-dear>
            </div>

            <div *ngIf="partner && !selectPOS">
              <div class="no-pos-message">{{ 'onboarding.messages.no_pos_selected_continue' | translate }}</div>
              <div *ngIf="partner.VerificationID" class="margin-top-32">
                <div class="row">
                  <div class="col-md-6">
                    <button pButton (click)="skipToHubtiger()" [disabled]="creatingDummyData"
                            class="p-button alternate full-width"
                            label="{{ 'onboarding.button.skip_to_hubtiger' | translate}}"></button>
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


    </div>
</div>
